import type { ConsentSource } from "@/core/consent/sources/consent.source";

// `globalPrivacyControl` is a draft spec property, so it is not in TS's DOM
// lib yet. Declared here rather than imported from the legacy consent module
// so the instrumentation stack has no dependency on code it will replace;
// TypeScript merges this with the identical legacy declaration.
declare global {
  interface Navigator {
    globalPrivacyControl?: boolean;
  }
}

/**
 * Emits `GpcAsserted` once when the browser carries Global Privacy Control.
 * The signal is set for the life of the browser session — there is nothing to
 * listen to after the initial read, so the source emits synchronously on
 * start and the stop function has nothing to tear down. Strict `=== true`
 * mirrors the legacy `isGlobalPrivacyControlEnabled`: an absent or malformed
 * value must never read as an opt-out the visitor did not make.
 */
export const createGpcSource = (): ConsentSource => ({
  start(emit) {
    if (typeof navigator !== "undefined" && navigator.globalPrivacyControl === true) {
      emit({ type: "gpcAsserted" });
    }

    return () => {};
  },
});
